import * as React from "react";
import { cn } from "@/lib/utils";

export interface SkeletonProps extends React.HTMLAttributes<HTMLSpanElement> {
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  borderRadius?: number | string;
  /** Accepted for backwards compatibility; the shimmer always follows theme tokens. */
  baseColor?: string;
  highlightColor?: string;
}

/**
 * Theme-aware loading placeholder. Uses the shared `.skeleton-shimmer`
 * material (index.css) so every loading surface in the app moves the same
 * way, and is announced to assistive tech only once by its container.
 */
function Skeleton({
  className,
  width,
  height,
  circle,
  borderRadius,
  baseColor: _baseColor,
  highlightColor: _highlightColor,
  style,
  ...props
}: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "skeleton-shimmer block",
        circle ? "rounded-full" : "rounded-md",
        !height && !className?.match(/\bh-/) && "h-4",
        className,
      )}
      style={{
        width,
        height,
        ...(borderRadius !== undefined ? { borderRadius } : null),
        ...style,
      }}
      {...props}
    />
  );
}

export { Skeleton };
export default Skeleton;
